export enum Endpoint {

  //tws-endpoints
  //Authentication
  INFORMATION = '/pending-approval-service/resources/information',
  AUTHENTICATION = '/pending-approval-service/resources/authentication',
  LOGOUT = '/pending-approval-service/resources/logout',

  //tws-locale
  GET_LOCALE_AND_LANGUAGE = '/pending-approval-service/resources/locale',

  //Terms
  CHECK_ASSIGN_TERMS = '/pending-approval-service/resources/terms/check-assign-terms',
  CHECK_TERMS = '/pending-approval-service/resources/terms/check-terms/:type',
  GET_LATEST_TERMS = '/pending-approval-service/resources/terms/terms-sequence/:type',
  UPDATE_TERMS = '/pending-approval-service/resources/terms/term-confirm/:type',

  //Profile
  GET_PROFILE = '/pending-approval-service/resources/profile',
  GET_PROFILE_LAST_ACCESS = '/pending-approval-service/resources/profile/last-access',

  //microservice endpoints
  //File Protocol
  GET_FILE_PROTOCOL = '/cci-platform-pending-approval-ms/file-protocol/:id',
  DUPLICATE_FILE_PROTOCOL = '/cci-platform-pending-approval-ms/file-protocol/duplicate-file-protocol',

  //Purchase approval
  OPINION_REQUEST = '/cci-platform-pending-approval-ms/purchase-approval/opinion-request',
  INFORM_OPINION = '/cci-platform-pending-approval-ms/inform-opinion',

  //approval items
  GET_APPROVAL_ITEMS_LIST = '/cci-platform-pending-approval-ms/approval-item/:id/:processId',
  GET_ROLES = '/cci-platform-pending-approval-ms/role',
  GET_USER_WITH_ROLEID = '/cci-platform-pending-approval-ms/approval-forward/users/role/:roleId',
  GET_USER_WITHOUT_ROLEID = '/cci-platform-pending-approval-ms/approval-forward/users',
  FORWARD_VERIFICATION = '/cci-platform-pending-approval-ms/approval-forward/validate',
  FORWARD_PENDING_PROCESS = '/cci-platform-pending-approval-ms/approval-forward',
  DISAPPROVE_PENDING_PROCESS = '/cci-platform-pending-approval-ms/disapprove',
  GET_DISAPROVE_REASONS = '/cci-platform-pending-approval-ms/disapprove/reasons',

  //Approval list
  APPROVAL_LIST = '/cci-platform-pending-approval-ms/approval-list',

  //Approval Reports
  APPROVAL_REPORTS = '/pending-approval-service/resources/reports/:documentNumber/report/generate',
  APPROVAL_FILE_URI = '/pending-approval-service/resources/files/preview/',

  //Approval Process
  APPROVE = '/cci-platform-pending-approval-ms/approval-process/approve',
  VALIDATE_PURCHASE_UNIT_VALUE = '/cci-platform-pending-approval-ms/approval-process/validate-purchase-unit-value',
  GENERATE_LOG_APPROVAL_PROCESS = '/cci-platform-pending-approval-ms/approval-process/log-approval-process',
  FORWARD_BALANCE_APPROVAL = '/cci-platform-pending-approval-ms/approval-process/forward-balance-approval',
  APPROVE_PURCHASE = '/cci-platform-pending-approval-ms/approval-process/approve-purchase',
  GENERATE_PURCHASE_REQUEST_INTEGRATION = '/cci-platform-pending-approval-ms/approval-process/generate-purchase-request-integration',
}
